export const config = {
  api: {
    baseUrl: process.env.REACT_APP_CORE_API_BASE_URL ?? '',
  },
  cloudinary: {
    apiKey: process.env.REACT_APP_CLOUDINARY_API_KEY ?? '',
    cloudName: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME ?? '',
  },
  donorApp: {
    baseUrl: process.env.REACT_APP_DONOR_APP_BASE_URL ?? '',
  },
  givzEnv: process.env.REACT_APP_GIVZ_ENV ?? '',
  maxDonationValue: 1000,
  sentry: {
    dsn: process.env.REACT_APP_SENTRY_DSN ?? '',
    environment: process.env.REACT_APP_SENTRY_ENV ?? 'development',
  },
};
